import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";

import { slackInstallationQueryKey } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface DisconnectSlackResponse {
  success: boolean;
}

export const useDisconnectSlack = (
  workspaceId: number | null,
): UseMutationResult<DisconnectSlackResponse, Error, void> => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (): Promise<DisconnectSlackResponse> => {
      if (workspaceId === null) {
        throw new Error("No active workspace to disconnect Slack from.");
      }
      const res = await fetch(ENDPOINTS.slack.deleteInstallation, {
        method: "DELETE",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify({ workspace_id: workspaceId }),
      });
      return handleResponse(res);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: slackInstallationQueryKey(workspaceId ?? 0) });
    },
  });
};
